enum EDefaultRouteName {
  HOME = 'home',
  COOPERATION_REFUSED = 'cooperationRefused',
  NOT_FOUND_PAGE = 'notFound',
}

export default EDefaultRouteName;
